import {useEffect} from "react";

export const useOutsideClick = (refs, handler, when = true) => {
    useEffect(() => {
        if (!when) return;

        const listener = (event) => {
            const path = event.composedPath?.() ?? [];
            const isInside = refs.some((r) => {
                const el = r?.current;
                return el && (path.includes(el) || el.contains(event.target));
            });

            if (isInside) return;
            handler?.(event);
        };

        document.addEventListener("click", listener, true);

        return () => document.removeEventListener("click", listener, true);
    }, [when, handler, refs]);
};
